<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <d-row no-gutters class="page-header py-4">
            <h3 class="page-title">Google Analytics V4</h3>
        </d-row>
        <d-row>
            <d-col cols="12" md="10" lg="8" :offset-md="1" :offset-lg="2">
                <d-card class="mt-2">
                    <d-card-body>
                        <div class="form-group">
                            <label>Measurement Id</label>
                            <d-input required readonly v-model="measurementId" />
                        </div>
                        <div class="form-group d-flex">
                            <label>
                                Landing Page tracking
                                &nbsp;
                            </label>
                            <toggle-button
                                v-model="isEnabledLpTracking"
                                :labels="true"
                                :sync="true"
                            />
                        </div>
                        <div class="form-group">
                            <b-form-group
                                label="Push disapproved transactions as refunds"
                            >
                                <b-form-radio
                                    v-model="selectedCronTime"
                                    name="pushed-disapproved-negatives-cron"
                                    :value="null"
                                >
                                    Off
                                </b-form-radio>
                                <b-form-radio
                                    v-model="selectedCronTime"
                                    name="pushed-disapproved-negatives-cron"
                                    value="* * * * *"
                                >
                                    Realtime
                                </b-form-radio>
                                <b-form-radio
                                    v-model="selectedCronTime"
                                    name="pushed-disapproved-negatives-cron"
                                    :value="selectedCronTimeCronForWeekDay"
                                >
                                    On a specific day of the week
                                    <b-form-select
                                        class="d-inline-block"
                                        v-model="selectedCronTime"
                                        :options="optionsCronForWeek"
                                    ></b-form-select>
                                </b-form-radio>
                                <b-form-radio
                                    v-model="selectedCronTime"
                                    name="pushed-disapproved-negatives-cron"
                                    value="* 20 1 * *"
                                >
                                    First day of the month
                                </b-form-radio>
                                <p class="mt-3 mb-0">
                                    <strong>Please note!</strong> We only send transactions as refunds if transaction status changed from pending to disapproved
                                </p>
                            </b-form-group>
                        </div>
                        <div class="form-group">
                            Exit or Landing page tracking
                            <b-form-select
                                class="d-inline-block"
                                v-model="selectedPageDataOption"
                                :options="pageDataOptions"
                            >
                            </b-form-select>
                        </div>
                        <div class="text-center mb-3">
                            <button @click="save" class="d-inline-block btn btn-success">Save</button>
                        </div>
                    </d-card-body>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
import {ErrorService, GoogleAnalyticsV4Service, UserService} from "@/main";
import notification from "@/mixins/notification";
import Loading from "vue-loading-overlay";
import ConfigurationList from "@/components/ga-v4/ConfigurationList.vue";
import GoogleSignIn from "@/components/integrations/google-analytics-oauth/oauth/GoogleSignIn.vue";

export default {
    mixins: [notification],
    components: {
        GoogleSignIn,
        ConfigurationList,
        Loading,
    },

    data() {
        return {
            measurementId: null,
            isEnabledLpTracking: null,
            selectedCronTime: null,
            selectedPageDataOption: null,

            optionsCronForWeek: [
                {
                    value: "* 20 * * 1",
                    text: "Monday"
                },
                {
                    value: "* 20 * * 2",
                    text: "Tuesday"
                },
                {
                    value: "* 20 * * 3",
                    text: "Wednesday"
                },
                {
                    value: "* 20 * * 4",
                    text: "Thursday"
                },
                {
                    value: "* 20 * * 5",
                    text: "Friday"
                },
                {
                    value: "* 20 * * 6",
                    text: "Saturday"
                },
                {
                    value: "* 20 * * 0",
                    text: "Sunday"
                }
            ],
            pageDataOptions: [
                {
                    value: null,
                    text: 'Not activated'
                },
                {
                    value: 'landingpage',
                    text: 'Landingpage as page location'
                },
                {
                    value: 'exitpage',
                    text: 'Exit page as page location'
                },
            ],
        };
    },

    computed: {
        selectedCronTimeCronForWeekDay() {
            let selectedCronTime = this.optionsCronForWeek.findIndex(
                option => option.value === this.selectedCronTime
            );
            return selectedCronTime !== -1
                ? this.selectedCronTime
                : this.optionsCronForWeek[0].value;
        }
    },

    methods: {
        async save() {
            try {
                await GoogleAnalyticsV4Service.updateConnection(
                    this.$route.params.websiteId,
                    this.isEnabledLpTracking,
                    this.selectedCronTime,
                    this.selectedPageDataOption
                )
                this.showNotification('success', 'Alert', 'Google Analytics V4 settings saved!')
                if (this.$route.query.redirect) {
                    console.log('ff', this.$route.query.redirect)
                    this.$router.push(this.$route.query.redirect)
                    return
                }
                this.$router.push({ name: 'network', params: { id: this.$route.params.websiteId }})
            } catch(e) {
                this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                console.log(e)
            }
        },

        async init() {
            const integrations = await UserService.getIntegrations(this.$route.params.websiteId)
            const ga4 = integrations.googleAnalyticsV4Integration
            this.measurementId = ga4.measurement_id
            this.isEnabledLpTracking = ga4.is_enabled_lp_tracking
            this.selectedCronTime = ga4.send_refunds
            this.selectedPageDataOption = ga4.page_data_option
        }
    },

    async mounted() {
        await this.init()
    }
};
</script>
